
import {
  defineComponent,
  reactive,
  SetupContext,
  ref,
  toRefs,
  watch,
  onMounted,
  watchEffect
} from 'vue'
import { useRouter, useRoute } from 'vue-router'
import {
  useAxiosGameInfo,
  setHeaders,
  setRedenvelopeBaseUrl
} from '../axios/index'
import { isValid } from '@/classes/ChekType.ts'
import usePopup from '@/components/Popup/index.ts'

// components
import Roulette from '@/components/Roulette/index.vue'
import Banner from '@/components/Banner/index.vue'
import Popup from '@/components/Popup/index.vue'
import Tabs from '@/components/Tabs/index.vue'
import Tab from '@/components/Tabs/Tab/index.vue'
// import Chance from '@/components/Chance/index.vue'
// import Share from '@/components/Share/index.vue'
import BackTop from '@/components/BackTop/index.vue'

interface winData {
  play_times: number
  prize_name: string
  prize_point: string | number
  prize_type: number
  sort: number
  statusCodeType: string
  wording: string
}

const { result, init } = useAxiosGameInfo()
const {
  dataIndex,
  isDisplay,
  openPopup,
  closePopup,
  popupTypeName
} = usePopup()

function setGameInfoPlayTimes(times: number): void {
  result.play_times = times
}

function finishGame(data: winData): void {
  const { prize_type, prize_point, prize_name, play_times } = data

  setGameInfoPlayTimes(play_times)

  switch (prize_type) {
    case 1:
      openPopup('gift', 1, prize_point, prize_name)
      break
    case 2:
      openPopup('gift', 0, prize_point, prize_name, prize_point)
      break
    case 3:
      openPopup('gift', 2, prize_point, prize_name)
      break
    case 4:
      openPopup('message', 0)
      break

    default:
      break
  }
}

export default defineComponent({
  name: 'GhostFestival',
  components: {
    Roulette,
    Banner,
    Popup,
    Tabs,
    // Chance,
    // Share,
    Tab,
    BackTop
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const queryGameKey = ref('')
    const { query } = route
    const closePopupCallback = ref()

    setRedenvelopeBaseUrl()

    setQueryValue()

    if (isValid(queryGameKey.value)) {
      setHeaders('gameKey', queryGameKey.value)
      init()
    } else {
      openPopup('loudspeaker', 2)
    }

    function setClosePopupCallback(func: Function) {
      closePopupCallback.value = func
    }
    function handleClosePopup() {
      closePopup()
      closePopupCallback?.value?.()
      setClosePopupCallback(() => {})
    }

    function setQueryValue(): void {
      if (typeof query.gameKey === 'string' && query.gameKey !== '') {
        queryGameKey.value = encodeURIComponent(
          decodeURIComponent(query.gameKey)
        )
        // queryGameKey.value =
        //   '1GAO86BO3hkCHEFN7BQEt79bT%2FI%2FAvYy6Iyf2%2FFCnNKlqo8ZArxwDpxJ9hiAvy6cF3tZLqO4uxgx1Ws8BJ5%2Bxw%3D%3D'
      }
    }

    function handleTabIndex(tabName: String): void {
      router.push({
        name: tabName.toString()
      })
    }

    async function shareHandler(): Promise<void> {
      if (!isValid(result.share_url) || !isValid(result.share_wording)) return

      const SHARE_TYPE = 2
      await init(SHARE_TYPE)

      setShareInfoToMobile()
    }

    function setShareInfoToMobile(): void {
      const shareInfo = JSON.stringify({
        share_url: result.share_url,
        share_wording: result.share_wording
      })

      window.MobileApp.call(shareInfo, 'share')
    }

    return {
      ...toRefs(result),
      ...toRefs(dataIndex),
      closePopup,
      openPopup,
      handleTabIndex,
      popupTypeName,
      finishGame,
      isDisplay,
      shareHandler,
      setClosePopupCallback,
      handleClosePopup
    }
  }
})
